<script setup>
import CrossCloseNotifySvg from "@/components/UI/svg/CrossCloseNotifySvg.vue";
import CrossSvg from "@/components/UI/CrossSvg.vue";
import {ref, defineEmits, defineModel, watchEffect} from "vue";
import { VueDatePicker } from '@vuepic/vue-datepicker';
import { ru } from 'date-fns/locale'
import ErrorTriangleSvg from "@/components/UI/svg/ErrorTriangleSvg.vue";
import DropdownComponent from "@/components/UI/DropdownComponent.vue";
import VKAdsSvg from "@/components/UI/svg/services/VKAdsSvg.vue";
import SelectVKAccountModal from "@/components/VKAdwordsStatistics/SelectVKAccountModal.vue";

const isToggle = ref(false)
const isAccModalVisible = ref(false)
const selectedAccount = defineModel('account')

const emits = defineEmits(['next-step', 'change-step'])

function toggleAccModal() {
  isAccModalVisible.value = !isAccModalVisible.value
}

const uploadOptions = ref({
  offsetOperation: [
    {
      name: 'Плюс',
      type: 'PLUS'
    },
    {
      name: 'Минус',
      type: 'MINUS'
    },
  ],
  offsetNames: [
    {
      name: 'Дней',
      type: 'DAY'
    },
    {
      name: 'Месяцев',
      type: 'MONTH'
    },
  ]
})

const startExactDate = ref({
  type: "exact",
  date: null
})

const startOffsetDate = ref({
  type: "offset",
  length: 0,
  offsetOperation: uploadOptions.value.offsetOperation[0],
  offsetName: uploadOptions.value.offsetNames[0]
})

const endExactDate = ref({
  type: "exact",
  date: null
})

const endOffsetDate = ref({
  type: "offset",
  length: 0,
  offsetOperation: uploadOptions.value.offsetOperation[0],
  offsetName: uploadOptions.value.offsetNames[0]
})

const timeOffsetStart = ref(0)
const timeOffsetEnd = ref(0)

const startDate = defineModel('startDate')
const endDate = defineModel('endDate')

const errorMessage = ref("")

const handleInputStart = (event) => {
  const value = event.target.value
  const numericValue = value.replace(/[^\d]/g, '')
  const limitedValue = numericValue.slice(0, 4)
  timeOffsetStart.value = limitedValue === '' ? 0 : Number(limitedValue)
}

const handleInputEnd = (event) => {
  const value = event.target.value
  const numericValue = value.replace(/[^\d]/g, '')
  const limitedValue = numericValue.slice(0, 4)
  timeOffsetEnd.value = limitedValue === '' ? 0 : Number(limitedValue)
}

function getDate(date) {
  if (!date) return null

  if (date.type === 'offset') {
    const today = new Date()
    const result = new Date(today) // Создаем копию

    if (date.length === "") return null
    // Определяем направление смещения
    const multiplier = date.offsetOperation?.type === 'MINUS' ? -1 : 1

    if (date.offsetName?.type === 'MONTH') {
      result.setMonth(result.getMonth() + (date.length * multiplier))
      return result
    }
    if (date.offsetName?.type === 'DAY') {
      result.setDate(result.getDate() + (date.length * multiplier))
      return result
    }
  }

  if (date.type === 'exact') {
    return date.date ? new Date(date.date) : null
  }

  return null
}
const isDataInputRight = ref(false)


watchEffect(() => {
  if (selectedAccount.value === null) {
    errorMessage.value = "Выберите аккаунт"
    isDataInputRight.value = false
    return
  }
  if (startDate.value === null || endDate.value == null) {
    isDataInputRight.value = false
    return
  }
  const start = getDate(startDate.value)
  const end = getDate(endDate.value)

  if (start === null || end === null) {
    errorMessage.value = "Выберите период выгрузки"
    isDataInputRight.value = false
    return
  }
  if (end < start) {
    console.log(new Date(end))
    console.log(new Date(start))
    errorMessage.value = "Дата окончания предшествует дате начала"
    isDataInputRight.value = false
    return
  }
  isDataInputRight.value = true;

})


function updateAccount(account) {
  selectedAccount.value = account
}

function toggleSelf() {
  isToggle.value = !isToggle.value
}

function nextStep() {
  isToggle.value = true
  emits('next-step')
}

</script>

<template>
  <div class="relative w-full">
    <div
        v-show="isToggle"
        class="w-full bg-white rounded-3xl h-24 sm:h-32 flex items-center justify-between shadow-xl border-2 border-transparent cursor-pointer hover:border-blue-500 transition-all duration-150"
        v-on:click="toggleSelf"
    >
      <div class="flex items-center justify-center">
        <VKAdsSvg class="size-12 sm:size-16 lg:size-20 ml-3 sm:ml-5 mr-2" />
        <div class="ml-1 sm:ml-0">
          <div class="font-bold text-lg sm:text-xl">
            Статистика
          </div>
          <div class="text-sm sm:text-base">
            VK Реклама
          </div>
        </div>
      </div>
      <div
          class="mr-3 sm:mr-10 size-8 sm:size-10 flex items-center justify-center rounded-full hover:bg-gray-200 cursor-pointer transition-all duration-150"
      >
        <CrossSvg class="size-6 sm:size-8"/>
      </div>
    </div>

    <div
        v-show="!isToggle"
        class="w-full flex flex-col justify-center items-start bg-white rounded-3xl shadow-xl px-4 sm:px-6 lg:px-10 pb-16 sm:pb-20"
    >
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center h-20 sm:h-24 lg:h-32">
          <VKAdsSvg class="size-12 sm:size-16 lg:size-20 mr-2 sm:mr-4" />
          <div>
            <div class="font-bold text-lg sm:text-xl lg:text-2xl">
              Статистика
            </div>
            <div class="text-sm sm:text-base lg:text-lg">
              VK Реклама
            </div>
          </div>
        </div>
        <div
            class="size-8 sm:size-10 flex items-center justify-center rounded-full hover:bg-gray-200 cursor-pointer transition-all duration-150"
            v-on:click="emits('change-step')"
        >
          <CrossCloseNotifySvg class="size-6 sm:size-8"/>
        </div>
      </div>

      <div class="w-full">
        <div class="mt-6 mb-3 sm:mb-4 font-bold text-base sm:text-lg">
          Выбрать аккаунт для выгрузки статистики
        </div>
            <div class="flex w-full flex-col items-stretch justify-between gap-4 rounded-md border p-3 sm:flex-row sm:items-center sm:gap-0 sm:py-3">

              <!-- Левая часть: Аватар и Имя -->
                <div class="flex items-center gap-3 sm:gap-4">

                  <!-- Аватар с инициалами -->
                    <div class="flex size-12 sm:size-16 md:size-20 flex-shrink-0 items-center justify-center rounded-full bg-blue-500">
                        <span class="text-lg font-bold text-white">
                            {{ selectedAccount?.firstname[0] }}{{ selectedAccount?.lastname[0] }}
                        </span>
                    </div>

                  <!-- Имя или заглушка -->
                    <span class="truncate text-sm font-bold sm:text-base">
                        {{ selectedAccount ? selectedAccount.firstname + ' ' + selectedAccount.lastname : 'Аккаунт не выбран' }}
                    </span>

                </div>

              <!-- Правая часть: Кнопка -->
              <button
                  @click="toggleAccModal"
                  class="mr-10 flex h-10 cursor-pointer items-center justify-center whitespace-nowrap rounded-lg bg-blue-500 px-4 py-2 text-sm font-bold text-white transition-all duration-150 hover:bg-blue-600 sm:px-3 sm:py-0 sm:text-base"
              >
                  Выбрать аккаунт
              </button>

          </div>
      </div>
      <div class="w-full mt-8 sm:mt-10">
        <div class="mb-3 sm:mb-4 font-bold text-base sm:text-lg">
          Параметры выгрузки статистики
        </div>
        <div class="flex flex-col lg:flex-row gap-8 lg:gap-12 xl:gap-16">
          <div class="flex-1 min-w-0">
            <div class="font-bold mb-4 sm:mb-5 text-base">Начало</div>
            <div class="flex flex-col">
              <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 lg:gap-10 mb-6 sm:mb-8 lg:mb-10">
                <div class="flex items-center w-fit whitespace-nowrap">
                  <input
                      id="start-radio-1"
                      type="radio"
                      :value="startExactDate"
                      :checked="startDate.type === startExactDate.type"
                      v-model="startDate"
                      class="w-4 h-4"
                  >
                  <label for="start-radio-1" class="select-none ms-2 text-sm sm:text-base font-medium text-heading">
                    Точная дата
                  </label>
                </div>
                <VueDatePicker
                    v-show="startDate.type === 'exact'"
                    v-model="startDate.date"
                    :formats="{ input: 'dd.MM.yyyy' }"
                    :time-config="{ enableTimePicker: false }"
                    :locale="ru"
                    :disabled="startDate.type !== startExactDate.type"
                    class="w-full sm:w-36"
                    auto-apply
                />
              </div>

              <div class="flex items-center mb-4">
                <input
                    id="start-radio-2"
                    type="radio"
                    :value="startOffsetDate"
                    :checked="startDate.type === startOffsetDate.type"
                    v-model="startDate"
                    class="w-4 h-4"
                >
                <label for="start-radio-2" class="select-none ms-2 text-sm sm:text-base font-medium text-heading">
                  Смещение от текущей даты
                </label>
              </div>

              <div class="flex flex-col sm:flex-row gap-2" v-show="startDate.type==='offset'">
                <DropdownComponent v-model:value="startDate.offsetOperation" :values="uploadOptions.offsetOperation" label-key="name" />
                <input
                    v-model="startDate.length"
                    @input="handleInputStart"
                    class="w-16 px-3 py-2 border rounded-lg text-sm sm:text-sm text-right bg-white flex justify-between items-center"
                    placeholder="90"
                >
                <DropdownComponent v-model:value="startDate.offsetName" :values="uploadOptions.offsetNames" label-key="name" />
              </div>
            </div>
          </div>

          <div class="flex-1 min-w-0">
            <div class="font-bold mb-4 sm:mb-5 text-base">Конец</div>
            <div class="flex flex-col">
              <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 lg:gap-10 mb-6 sm:mb-8 lg:mb-10">
                <div class="flex items-center w-fit whitespace-nowrap">
                  <input
                      id="end-radio-1"
                      type="radio"
                      :value="endExactDate"
                      :checked="endDate.type === endExactDate.type"
                      v-model="endDate"
                      class="w-4 h-4"
                  >
                  <label for="end-radio-1" class="select-none ms-2 text-sm sm:text-base font-medium text-heading">
                    Точная дата
                  </label>
                </div>
                <VueDatePicker
                    v-show="endDate.type === 'exact'"
                    v-model="endDate.date"
                    :formats="{ input: 'dd.MM.yyyy' }"
                    :time-config="{ enableTimePicker: false }"
                    :locale="ru"
                    :disabled="endDate.type !== endExactDate.type"
                    class="w-full sm:w-36"
                    auto-apply
                />
              </div>

              <div class="flex items-center mb-4">
                <input
                    id="end-radio-2"
                    type="radio"
                    :value="endOffsetDate"
                    :checked="endDate.type === endOffsetDate.type"
                    v-model="endDate"
                    class="w-4 h-4"
                >
                <label for="end-radio-2" class="select-none ms-2 text-sm sm:text-base font-medium text-heading">
                  Смещение от текущей даты
                </label>
              </div>

              <div class="flex flex-col sm:flex-row gap-2" v-show="endDate.type==='offset'">
                <DropdownComponent v-model:value="endDate.offsetOperation" :values="uploadOptions.offsetOperation" label-key="name" />
                <input
                    v-model="endDate.length"
                    @input="handleInputEnd"
                    class="w-16 px-3 py-2 border rounded-lg text-sm sm:text-sm text-right bg-white flex justify-between items-center"
                    placeholder="90"
                >
                <DropdownComponent v-model:value="endDate.offsetName" :values="uploadOptions.offsetNames" label-key="name" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-5 mt-8" v-show="!isDataInputRight">
        <ErrorTriangleSvg class="size-6 stroke-white fill-red-500"/>
        <div>
          {{ errorMessage }}
        </div>
      </div>
    </div>

    <div
        class="absolute bottom-5 right-5 z-30 px-4 sm:px-5 py-2 sm:py-3 rounded-full bg-blue-500 hover:bg-blue-600 duration-150 transition-all cursor-pointer select-none font-bold text-white -translate-x-1/2 -translate-y-1/2 text-sm sm:text-base whitespace-nowrap"
        :class="{'bg-gray-400 hover:bg-gray-400 text-gray-600 cursor-default': !isDataInputRight}"
        v-show="!isToggle"
        v-if="isDataInputRight"
        v-on:click="nextStep"
    >
      Следующий шаг
    </div>
    <div
        class="absolute bottom-5 right-5 z-30 px-4 sm:px-5 py-2 sm:py-3 rounded-full bg-blue-500 hover:bg-blue-600 duration-150 transition-all select-none font-bold text-white -translate-x-1/2 -translate-y-1/2 text-sm sm:text-base whitespace-nowrap"
        :class="{'bg-gray-400 hover:bg-gray-400 text-gray-600': !isDataInputRight}"
        v-show="!isToggle"
        v-else
    >
      Следующий шаг
    </div>
  </div>

  <SelectVKAccountModal
      v-model:is-visible="isAccModalVisible"
      @update:account="updateAccount"
  />
</template>

<style scoped>
input[type="radio"] {
  @apply cursor-pointer;
}

select {
  @apply cursor-pointer bg-white;
}

.hover\:border-blue-500:hover {
  border-color: #3b82f6;
}

.relative {
  isolation: isolate;
}

@media (max-width: 480px) {
  .text-sm {
    font-size: 13px;
  }

  .size-12 {
    width: 2.5rem;
    height: 2.5rem;
  }

  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>